import axios from "axios";
import store from "@/store";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API
});

instance.interceptors.request.use(function(config) {
  //if (store.state.auth.token !== null) {
  config["headers"] = {
    //Authorization: `Bearer ${store.state.auth.token}`
    "Access-Control-Allow-Origin": "*"
  };

  let loadingCnt = store.getters["system/getLoading"];
  loadingCnt += 1;
  store.commit("system/setLoading", loadingCnt);
  if (loadingCnt > 0) {
    $(".loading-wrap").show();
  }
  return config;
});

instance.interceptors.response.use(
  function(response) {
    let loadingCnt = store.getters["system/getLoading"];
    loadingCnt -= 1;
    store.commit("system/setLoading", loadingCnt);
    if (loadingCnt < 1) {
      $(".loading-wrap").hide();
    }
    return response;
  },
  function(error) {
    //, config, code, request, response
    // console.log("------------error----------");
    // console.log(error);
    // console.log(config);
    // console.log(code);
    // console.log(request);
    // console.log(response);
    // console.log("------------error end----------");
    let loadingCnt = store.getters["system/getLoading"];
    loadingCnt -= 1;
    store.commit("system/setLoading", loadingCnt);
    if (loadingCnt < 1) {
      $(".loading-wrap").hide();
    }

    return Promise.reject(error);
  }
);

export default instance;
